import * as Sentry from '@sentry/browser';

import { REACT_APP_ENVIRONMENT, SENTRY_DSN } from 'shared/config';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    debug: true,
    environment: REACT_APP_ENVIRONMENT,
    tracesSampleRate: 0.5,
    integrations: [
      new Sentry.Integrations.Breadcrumbs({
        console: false,
      }),
    ],
  });
}
